import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';
import { get, del, post, put } from '../util';

const CATEGORIES_FILES = 'categoriesFiles';
const MANAGER = 'manager';
const LIST = 'list';
const CATEGORY_ID = 'categoryId';

//#region GET
export const getImageCategories = async ({ header }) => { 
  const pathUrl = `${endpoints.API_FORMS}/${CATEGORIES_FILES}/${MANAGER}/${LIST}`; 
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getImageCategoryById = async ({ header, imageCategoryId }) => { 
  const pathUrl = `${endpoints.API_FORMS}/${CATEGORIES_FILES}/${MANAGER}/${CATEGORY_ID}/${imageCategoryId}`; 
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};
//#endregion

//#region POST
export const createImageCategory = async ({ header, params }) => { 
  const pathUrl = `${endpoints.API_FORMS}/${CATEGORIES_FILES}/${MANAGER}`; 
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};
//#endregion

//#region PUT
export const updateImageCategory = async ({ header, params }) => { 
  const pathUrl = `${endpoints.API_FORMS}/${CATEGORIES_FILES}/${MANAGER}/${params.id}`; 
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};
//#endregion

//#region DELETE
export const deleteImageCategory = async ({ header, params }) => { 
  const pathUrl = `${endpoints.API_FORMS}/${CATEGORIES_FILES}/${MANAGER}/${params.id}`;
  const axios = interceptor(header);
  return await del(axios, pathUrl, params);
};
//#endregion 